var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1491_14199)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.925781,
    y: 0.599609,
    width: 15.8264,
    height: 15.7018,
    rx: 1.43789,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2520",
    d: "M14.4127 13.9342H12.0708V10.3028C12.0708 9.43681 12.0552 8.32206 10.8527 8.32206C9.63295 8.32206 9.44633 9.26555 9.44633 10.2397V13.934H7.10437V6.46623H9.35264V7.48678H9.38412C9.60912 7.10587 9.93425 6.79251 10.3249 6.58008C10.7155 6.36765 11.157 6.26411 11.6024 6.28048C13.976 6.28048 14.4137 7.8264 14.4137 9.83754L14.4127 13.9342ZM4.46188 5.44544C4.19309 5.44549 3.93031 5.36662 3.70678 5.21879C3.48326 5.07097 3.30904 4.86083 3.20613 4.61496C3.10322 4.36909 3.07625 4.09852 3.12865 3.83748C3.18104 3.57643 3.31044 3.33663 3.50047 3.1484C3.69051 2.96017 3.93264 2.83197 4.19627 2.78C4.45989 2.72803 4.73315 2.75463 4.9815 2.85643C5.22986 2.95824 5.44214 3.13068 5.59152 3.35195C5.7409 3.57322 5.82065 3.83338 5.8207 4.09953C5.82073 4.27624 5.78561 4.45123 5.71734 4.61451C5.64907 4.77779 5.549 4.92615 5.42282 5.05113C5.29664 5.17611 5.14683 5.27526 4.98195 5.34292C4.81708 5.41057 4.64036 5.44541 4.46188 5.44544ZM5.63285 13.9342H3.28847V6.46623H5.63285V13.9342ZM15.5803 0.600676H2.11165C1.80595 0.59726 1.51137 0.714155 1.29267 0.925673C1.07397 1.13719 0.949043 1.42603 0.945312 1.72871V15.12C0.948916 15.4228 1.07377 15.7119 1.29247 15.9236C1.51116 16.1353 1.8058 16.2525 2.11165 16.2492H15.5803C15.8867 16.2531 16.1822 16.1363 16.4017 15.9245C16.6213 15.7128 16.747 15.4234 16.7512 15.12V1.72775C16.7469 1.42446 16.6211 1.1353 16.4015 0.923783C16.182 0.71227 15.8866 0.595709 15.5803 0.599709",
    fill: "#0A66C2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1491_14199"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.925781,
    y: 0.599609,
    width: 15.8264,
    height: 15.7018,
    rx: 1.43789,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.8ea9375db89053f382b0169517e62207.svg";
export { ForwardRef as ReactComponent };